export { CanvasEditorComponent } from './canvas-editor.component';
